module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.15.0_gatsby@5.14.6_babel-eslint@10.1.0_eslint@7.32.0__react-do_c08f66cf7d5f1df7f44c1b32acfb56b8/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1ab3e659741f741febfaa5afdc364787"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.14.6_babel-eslint@10.1.0_eslint@7.32.0__react-dom@18.3.1_react@18.3.1__react@1_ea3a892360ba1511f67926e3639c1080/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
